export const getDate = () => {
    const now = new Date();

    const year = String(now.getFullYear()).slice(2, 4);
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Месяцы с 0, поэтому +1
    const day = String(now.getDate()).padStart(2, "0");

    return `${day}${month}${year}`;
};
